import PropTypes from 'prop-types'

// import { LAMA_LQIP } from '@aytm/app/stats/page/data-quality-report/lib/image-lqip'

import style from '@aytm/app/stats/page/data-quality-report/styles/sections/PaidViewpointPanel.module.scss'

const AWARD_YEARS = ['2020', '2021', '2022', '2023', '2024', '2025', '2026']
const CURRENT_AWARD_YEAR = AWARD_YEARS.find(year => year === String(new Date().getFullYear())) ?? null

// Targets are marketing destinations owned by panel-marketing.
const PILLS = [
  {
    key: 'survey-police',
    label: 'Survey police',
    icon: 'filled-protection',
    url: 'https://www.surveypolice.com/paidviewpoint'
  },
  {
    key: 'visit-panel',
    label: 'Visit the panel',
    icon: 'paid-viewpoint',
    url: 'https://paidviewpoint.com'
  },
  {
    key: 'panel-book',
    label: 'Panel Book 2026',
    icon: 'library-books',
    url: 'https://aytm.showpad.com/share/fGdVlk2dLsKkjbxxUd1dq'
  }
]

// Mostly-static brand panel (matches Figma 8009-21182): brand image left; rank + award years
// top, action pills top-right, blended-mode blurb below. Image/icon are placeholders until the
// exported assets are provided.
const PaidViewpointPanel = () => (
  <div data-testid="stat-dqr-paid-viewpoint" className={style.panel}>
    <img
      className={style.image}
      src="/images/data-quality/lama.jpg"
      alt="PaidViewpoint"
      width="200"
      height="200"
      // style={{ backgroundImage: `url(${LAMA_LQIP})` }}
    />

    <div className={style.content}>
      <div className={style.topRow}>
        <div className={style.summary}>
          <div className={style.rank}>
            <span className={style.rankNumber}>#1</span>
            <i className="icon-aytmfd-heart" />
            <span className={style.rankLabel}>panel</span>
          </div>

          <div className={style.years}>
            {AWARD_YEARS.map(year => (
              <span key={year} className={year === CURRENT_AWARD_YEAR ? style.yearCurrent : style.year}>
                {year}
              </span>
            ))}
          </div>
        </div>

        <div className={style.pills}>
          {PILLS.map(pill => (
            <a
              key={pill.key}
              data-testid={`stat-dqr-paid-viewpoint-pill-${pill.key}`}
              className="p-button p-component p-button-rounded p-button-bright-blue"
              href={pill.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className={`icon-aytmfd-${pill.icon} p-button-icon p-button-icon-left`} />
              <span className="p-button-label">{pill.label}</span>
            </a>
          ))}
        </div>
      </div>

      <div className={style.blurb}>
        <i className="icon-aytmfd-trusted-partner" />
        <p className={style.blurbText}>
          In the blended mode, we augment PV with the Trusted Partner Panels that extend the reach of our platform to
          the opinions of 100MM+ consumers.
        </p>
      </div>
    </div>
  </div>
)

PaidViewpointPanel.displayName = 'PaidViewpointPanel'
PaidViewpointPanel.propTypes = {
  state: PropTypes.string,
  tier: PropTypes.string,
  data: PropTypes.object
}
export default PaidViewpointPanel
